<h2 class="center-text">Your Games</h2>
<div>
	<div class="hrz-stretch game-list-header">
		<div class="title-col">TITLE</div>
		<div class="status-col">STATUS</div>
		<div class="button-col"></div>
	</div>
	<div *ngFor="let game of games" class="hrz-stretch game-info">
		<div class="title-col">
			<div class="hrz-stretch">
				<img width="80" class="rounded-avatar self-align-start" [src]="game.team.team_image ?game.team.team_image: default_team_avatar" alt="team_image">
				<div class="sm-ml game-desc">
					<strong><span class="text-capitalize">{{game.title}}</span> at {{game.venue}}</strong>
					<div>
						<span *ngIf="game.team?.team_name">Team: {{game.team.team_name}}</span>
						<br>
						<em> {{game.date | date:'mediumDate'}}, {{game.date | date:'shortTime'}}</em>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="!game.declined" class="status-col">
			<span [class.red]="game.status === 'live' && !game.invite">{{game.spectator ? 'watching': game.invite ? 'invited' :
				game.status}}</span>
			<div *ngIf="!game.loading" class="button-box">
				<button *ngIf="!game.invite || game.spectator" class="accept-btn" [disabled]="game.status !== 'live'"
					(click)="joinExisting(game)">Go To Game</button>
				<!-- <button *ngIf="game.invite && !game.spectator" (click)="linkJoin(game)">Accept</button>
				<button *ngIf="game.invite && !game.spectator" class="decline-btn"
					(click)="declineInvite(game)">Decline</button> -->
			</div>
			<h3 *ngIf="game.loading">One Moment...</h3>
		</div>
		<!-- <div *ngIf="game.declined" class="status-col">
			<span>Invite Declined</span>
		</div> -->
	</div>
</div>

